<template>
  <div class="brand-group flex">
    <div
      class="brand-group__item"
      v-for="(item, index) in brandList"
      :key="index"
      @click="handleBrandClick(item)"
    >
      <div class="brand-group__img-box">
        <img :src="item.src" class="brand-group__img" />
        <img
          :src="linkIcon"
          class="brand-group__icon-jump"
          v-if="linkIcon && checkIsShowLinkArrow(item)"
        />
      </div>
      <div class="brand-group__item-title">{{ item.title }}</div>
    </div>
  </div>
</template>
<script>
import {
  TYPE_JUMP_WEB,
  TYPE_JUMP_APP,
  TYPE_JUMP_WEAPP,
} from "../constant/types";
import Util from "../util";

export default {
  props: {
    brandList: {
      type: Array,
      default() {
        return [];
      },
    },
    linkIcon: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    checkIsShowLinkArrow(item) {
      return (
        (item.open_type === TYPE_JUMP_WEB ||
          item.open_type === TYPE_JUMP_APP ||
          item.open_type === TYPE_JUMP_WEAPP) &&
        !Util.isEmptyString(item.link)
      );
    },
    handleBrandClick(item) {
      window.sensors.track("JoinPageClick", {
        join_module_name: "媒体矩阵",
        join_name: item.title,
        join_destination_url: item.link,
      });
      this.$emit("onclick", item);
    },
  },
};
</script>
<style lang="scss" >
  .brand-group {
    width: 100%;
    height: 100%;
    flex-wrap: wrap;
    padding: 48px;
    justify-content: center;

    &__item {
      width: 128px;
      margin-right: 46px;
      margin-bottom: 40px;
      &:nth-of-type(4n) {
        margin-right: 0;
      }
    }
    &__img-box {
      width: 100%;
      height: 128px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      border-radius: 24px;
      border: 4px solid #d5ead2;
      position: relative;
    }
    &__img {
      width: 92px;
      height: 92px;
      pointer-events: none;
    }
    &__icon-jump {
      width: 32px;
      height: 32px;
      position: absolute;
      right: -1px;
      bottom: -1px;
    }
    &__item-title {
      margin-top: 12px;
      width: 200%;
      left: -50%;
      position: relative;
      height: 32px;
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #555555;
      line-height: 32px;
    }
  }
</style>
